import { Injectable } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormBuilderBase } from '@models';
import { TranslateService } from '__services';
import { of } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class FormBuilderService {

  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private translateService: TranslateService
  ) { }

  toFormGroup(forms: FormBuilderBase<string>[]): FormGroup {
    const group: any = {};

    forms.forEach(item => {
      group[item.key] = item.required ? new FormControl({value: item.value || '', disabled: item.disabled}, Validators.required)
        : new FormControl({value: item.value || '', disabled: item.disabled});
    });
    return this.fb.group(group);
  }

  orderItem(items: FormBuilderBase<any>[]): any {
    return items.sort((a, b) => a.order - b.order);
  }

  buildConfig(neededInfo: any[], allFields: object, fromWhere: string, viewMode?): any {
    const config: FormBuilderBase<string>[] = [];
    neededInfo.forEach(item => {
      config.push({
        key: item.key,
        label: this.translateService.translate(`${item.key}`),
        required: item.required,
        controlType: allFields[item.key].controlType,
        options: allFields[item.key]?.options || null,
        value: item.value,
        disabled: viewMode
      });
    });
    // return config.sort((a, b) => a.order - b.order);
    return of(config);
  }
}
